module.exports = __webpack_public_path__ + "img/Verletztes_Tier.80a0771e.svg";